import { numeric, helpers } from 'vuelidate/lib/validators';

export const ResponsReasonValidation: any = {
  ngl: { numeric },
  cus: { numeric },
  reason: {}
};
